<template>
    <div class="mt-5">
        <h3>Modulo Migración</h3>
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link active"
                    id="home-tab"
                    data-toggle="tab"
                    data-target="#home"
                    type="button"
                    role="tab"
                    aria-controls="home"
                    aria-selected="true"
                >
                    Migración
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button
                    class="nav-link"
                    id="profile-tab"
                    data-toggle="tab"
                    data-target="#profile"
                    type="button"
                    role="tab"
                    aria-controls="profile"
                    aria-selected="false"
                >
                    Obtener IDs de Comunidad
                </button>
            </li>
        </ul>
        <div class="tab-content" id="myTabContent">
            <div
                class="tab-pane fade show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
            >
                <p>
                    Este módulo le permitirá, según el año(s) elegido(s), migrar
                    todos los proyectos a la aplicación comunidad. Este proceso
                    enviará a cada participante un email con el que podrá
                    acceder a la red social de la plataforma SocialSkin
                    Comunidad.
                </p>

                <div class="my-3" v-if="years.length != 0">
                    <div class="form-inline">
                        <div class="form-group">
                            <select
                                class="form-control"
                                placeholder="Seleccione año a buscar"
                                v-model="yearSelected"
                            >
                                <option value="">
                                    Seleccione año a buscar
                                </option>
                                <option v-for="(year, idx) in years" :key="idx">
                                    {{ year }}
                                </option>
                            </select>
                        </div>
                        <button
                            type="submit"
                            class="btn btn-primary ml-2"
                            @click="getProjectsByYear"
                        >
                            Buscar
                        </button>
                    </div>
                </div>

                <section class="loading mt-4">
                    <stretch v-if="summaryRows.length === 0"></stretch>
                    <grid
                        :cols="summaryColumns"
                        :rows="summaryRows"
                        v-else
                    ></grid>
                </section>

                <section class="mt-4" v-if="yearSelected != ''">
                    <div>
                        <ul class="nav nav-tabs mt-3" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <button
                                    class="nav-link active"
                                    id="home-tab"
                                    data-toggle="tab"
                                    data-target="#home"
                                    type="button"
                                    role="tab"
                                    aria-controls="home"
                                    aria-selected="true"
                                    @click="getProjectsByYear"
                                >
                                    Proyectos
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button
                                    class="nav-link"
                                    id="profile-tab"
                                    data-toggle="tab"
                                    data-target="#profile"
                                    type="button"
                                    role="tab"
                                    aria-controls="profile"
                                    aria-selected="false"
                                    @click="getProjectsFinalistByYear"
                                >
                                    Finalistas
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button
                                    class="nav-link"
                                    id="contact-tab"
                                    data-toggle="tab"
                                    data-target="#contact"
                                    type="button"
                                    role="tab"
                                    aria-controls="contact"
                                    aria-selected="false"
                                    @click="getProjectsWinnerByYear"
                                >
                                    Ganadores
                                </button>
                            </li>
                        </ul>
                        <div class="tab-content" id="myTabContent">
                            <div
                                class="tab-pane fade show active"
                                id="home"
                                role="tabpanel"
                                aria-labelledby="home-tab"
                                v-if="projectsInitRender"
                            >
                                <h3>Proyectos Inscritos</h3>
                                <div>
                                    <button
                                        type="button"
                                        class="btn btn-primary my-2"
                                        @click="handleMasiveMigration('all')"
                                    >
                                        Migrar Todos
                                    </button>
                                    <grid
                                        :cols="projectColumns"
                                        :rows="projectsRows"
                                        :pagination="projectPaginate"
                                        :server="projectServer"
                                        :height="height"
                                        :language="language"
                                    ></grid>
                                </div>
                            </div>
                            <div
                                class="tab-pane fade"
                                id="profile"
                                role="tabpanel"
                                aria-labelledby="profile-tab"
                                v-if="projectsFinalistInitRender"
                            >
                                <h3>Finalistas</h3>
                                <div>
                                    <button
                                        type="button"
                                        class="btn btn-primary my-2"
                                        @click="
                                            handleMasiveMigration('finalists')
                                        "
                                    >
                                        Migrar Finalistas
                                    </button>
                                    <grid
                                        :cols="projectColumns"
                                        :rows="projectsFinalistRows"
                                        :pagination="projectsFinalistPaginate"
                                        :server="projectsFinalistServer"
                                        :height="height"
                                        :language="language"
                                    ></grid>
                                </div>
                            </div>
                            <div
                                class="tab-pane fade"
                                id="contact"
                                role="tabpanel"
                                aria-labelledby="contact-tab"
                                v-if="projectsWinnerInitRender"
                            >
                                <h3>Ganadores</h3>
                                <div>
                                    <button
                                        type="button"
                                        class="btn btn-primary my-2"
                                        @click="
                                            handleMasiveMigration('winners')
                                        "
                                    >
                                        Migrar Ganadores
                                    </button>
                                    <grid
                                        :cols="projectColumns"
                                        :rows="projectsWinnerRows"
                                        :pagination="projectsWinnerPaginate"
                                        :server="projectsWinnerServer"
                                        :height="height"
                                        :language="language"
                                    ></grid>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div
                class="tab-pane fade"
                id="profile"
                role="tabpanel"
                aria-labelledby="profile-tab"
            >
                <p>
                    Esta opción le permitirá, actualizar el ID del post de
                    comunidad asignado a cada uno de los proyectos registrados
                    en premio, esto le ayudará a que posteriormente pueda hacer
                    actualizaciones de datos entre ambas plataformas. Cabe
                    aclarar que esto solo funcionara para proyectos previamente
                    creados antes de abril de 2023.
                </p>
                <div class="card">
                    <div class="card-body">
                        <p>
                            <span class="font-weight-bold"
                                >Proyectos sin ID Post asociado de
                                comunidad:</span
                            >
                            {{ projectsWithOutCommunityPostId }}
                        </p>
                        <button
                            type="button"
                            aria-expanded="false"
                            class="btn btn-secondary btn btn-outline-primary active"
                            @click="handleUpdateCommunityPostIDInProjects"
                        >
                            Actualizar ID Comunidad En Proyectos
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from "dayjs";
import { Grid } from "gridjs-vue";
import { Stretch } from "vue-loading-spinner";
import { gridjsSpanishLanguage } from "../../utils/index";

export default {
    name: "MigrateProjectComponent",
    components: {
        Grid,
        Stretch,
    },
    props: {},
    data() {
        return {
            projectsInitRender: false,
            projectsFinalistInitRender: false,
            projectsWinnerInitRender: false,
            projectLoading: false,
            projectColumns: [
                "ID",
                "Nombre",
                "Concurso",
                "Pais",
                "Fecha Creación",
                {
                    name: "Acciones",
                    formatter: (_, row) => this.getOptionTable(row),
                },
            ],
            projectsRows: [],
            projectPaginate: {},
            projectServer: {},
            projectsFinalistRows: [],
            projectsFinalistPaginate: {},
            projectsFinalistServer: {},
            projectsWinnerRows: [],
            projectsWinnerPaginate: {},
            projectsWinnerServer: {},
            summaryColumns: [
                "Año",
                "Proyectos Inscritos",
                "Completos",
                "Finalistas",
                "Ganadores",
                "Migrados",
            ],
            summaryRows: [],
            yearSelected: "",
            years: [],
            height: "300px",
            language: gridjsSpanishLanguage(),
            email: "",
            projectsWithOutCommunityPostId: 0,
        };
    },
    computed: {},
    methods: {
        getSummary() {
            let me = this;
            axios
                .get("/api/projects/get-summary")
                .then(function (response) {
                    const { data } = response.data;
                    me.summaryRows = data.summary.map((col) => [
                        col.year,
                        col.registered,
                        col.completed,
                        col.finalists,
                        col.winners,
                        col.migrated,
                    ]);
                    me.years = data.summary.map((col) => col.year);
                    me.projectsWithOutCommunityPostId =
                        data.projects_with_out_community_post_id;
                })
                .catch(function (error) {
                    console.error(error.message);
                    me.showAlert(
                        "error",
                        "Ha ocurrido un error",
                        error.message
                    );
                });
        },

        getProjectsByYear() {
            this.projectsInitRender = true;

            this.projectPaginate = {
                enabled: true,
                limit: 15,
                server: {
                    url: (prev, page) => `${prev}&page=${page + 1}`,
                },
            };

            this.projectServer = {
                url: `${this.getServerUrl()}api/projects/get-by-year?year=${
                    this.yearSelected
                }`,
                then: (data) =>
                    data.data.data.map((col) => [
                        col?.id,
                        col?.name,
                        col?.contest.name,
                        col?.country?.name,
                        dayjs(col.created_at).format("YYYY-MM-DD"),
                        `${col?.id}|${col?.send_community}`,
                    ]),
                total: (data) => data.data.total,
            };
        },

        getProjectsFinalistByYear() {
            this.projectsFinalistInitRender = true;

            this.projectsFinalistPaginate = {
                enabled: true,
                limit: 15,
                server: {
                    url: (prev, page) => `${prev}&page=${page + 1}`,
                },
            };

            this.projectsFinalistServer = {
                url: `${this.getServerUrl()}api/projects/get-finalists?year=${
                    this.yearSelected
                }`,
                then: (data) =>
                    data.data.data.map((col) => [
                        col?.id,
                        col?.name,
                        col?.contest.name,
                        col?.country?.name,
                        dayjs(col.created_at).format("YYYY-MM-DD"),
                        `${col?.id}|${col?.send_community}`,
                    ]),
                total: (data) => data.data.total,
            };
        },

        getProjectsWinnerByYear() {
            this.projectsWinnerInitRender = true;

            this.projectsWinnerServerPaginate = {
                enabled: true,
                limit: 15,
                server: {
                    url: (prev, page) => `${prev}&page=${page + 1}`,
                },
            };

            this.projectsWinnerServer = {
                url: `${this.getServerUrl()}api/projects/get-winners?year=${
                    this.yearSelected
                }`,
                then: (data) =>
                    data.data.data.map((col) => [
                        col?.id,
                        col?.name,
                        col?.contest.name,
                        col?.country?.name,
                        dayjs(col.created_at).format("YYYY-MM-DD"),
                        `${col?.id}|${col?.send_community}`,
                    ]),
                total: (data) => data.data.total,
            };
        },

        showAlert(type, title, text) {
            this.$swal({
                title: title,
                text: text,
                icon: type,
                type: type,
                confirmButtonText: "Aceptar",
            });
        },

        loading() {
            this.$swal({
                text: "Procesando su solicitud, un momento por favor...",
                showConfirmButton: false,
                willOpen: () => {
                    this.$swal.showLoading();
                },
            });
        },

        closeLoading() {
            this.$swal.hideLoading();
        },

        migrateProject(projectId) {
            const me = this;
            this.$swal({
                title: `Esta seguro de migrar a comunidad el proyecto con ID ${projectId}`,
                text: "No podrás revertir esto!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#1c8eb7",
                cancelButtonColor: "#6c757d",
                confirmButtonText: "Si, Migrar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.isConfirmed) {
                    me.singleMigration(projectId);
                }
            });
        },

        singleMigration(projectId) {
            const me = this;
            me.loading();
            axios
                .post(`/api/projects/single-migration?project_id=${projectId}`)
                .then(function (response) {
                    const { data } = response.data;
                    if (data.success) {
                        me.showAlert(
                            "success",
                            `El registro ${data?.data?.post?.group} ha sido creado.`,
                            `El proyecto se ha migrado a comunidad.`
                        );
                    }
                })
                .catch(function (error) {
                    me.showAlert(
                        "error",
                        "Ha ocurrido un error",
                        error?.response?.data?.message ??
                            error?.response?.data?.messages
                    );
                })
                .finally(() => {
                    me.closeLoading();
                });
        },

        handleMasiveMigration(type) {
            const me = this;
            let params = {
                type: type,
                year: me.yearSelected,
                email: me.email,
            };
            this.$swal({
                title: `Ingresa un email para enviar el reporte.`,
                input: "text",
                text: "El resultado de esta operación se enviará al email indicado, ¿está seguro de migrar estos proyectos a comunidad? ¡No podrás revertir esto!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#1c8eb7",
                cancelButtonColor: "#6c757d",
                confirmButtonText: "Si, Migrar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.isConfirmed) {
                    params.email = result.value.toLowerCase().trim();
                    me.masiveMigration(params);
                }
            });
        },

        masiveMigration(params) {
            const me = this;
            me.loading();
            axios
                .post(
                    `/api/projects/multi-migration?year=${params.year}&type=${params.type}&email=${params.email}`
                )
                .then(function (response) {
                    const { data } = response.data;
                    if (data.success) {
                        me.showAlert(
                            "success",
                            `Migración ejecutada.`,
                            `${data.message}`
                        );
                    }
                })
                .catch(function (error) {
                    me.showAlert(
                        "error",
                        "Ha ocurrido un error",
                        error?.response?.data?.message ??
                            me.getErrorMessages(error?.response?.data?.messages)
                    );
                })
                .finally(() => {
                    me.closeLoading();
                });
        },

        getOptionTable(row) {
            // ejemplo: 19877|0 (el primer elemento antes del pipe es el id del proyecto y el segundo es un booleano que
            // indica si este se migro a comunidad o no) aca se separan por medio del split para hacer la validación respectiva y mostrar
            // el botón de migrar solo si el value[1] = 0.
            let values = row.cells[5].data.split("|");

            if (values[1] != 1) {
                return this.$gridjs.h(
                    "button",
                    {
                        className: "btn btn-warning",
                        onClick: () => this.migrateProject(row.cells[0].data),
                    },
                    "Migrar"
                );
            }
        },

        getServerUrl() {
            return document.querySelector('meta[name="app-url"]').content;
        },

        getErrorMessages(messages) {
            let response = ``;
            const keys = Object.keys(messages);

            for (const key of keys) {
                response = response + `${key}: ${messages[key]} , `;
            }

            return response;
        },

        handleUpdateCommunityPostIDInProjects() {
            this.$swal({
                title: `Estas seguro de realizar esta acción.`,
                text: "¡No podrás revertir esto!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3490DC",
                cancelButtonColor: "#6c757d",
                confirmButtonText: "Si, Actualizar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.isConfirmed) {
                    const me = this;
                    me.loading();
                    axios
                        .put(`/api/projects/homologate-post-id`)
                        .then(function (response) {
                            const { data } = response.data;
                            console.log(data);
                            if (data.success) {
                                me.showAlert(
                                    "success",
                                    `Actualización realizada.`,
                                    `${data.message}`
                                );
                            }
                        })
                        .catch(function (error) {
                            me.showAlert(
                                "error",
                                "Ha ocurrido un error",
                                error?.response?.data?.message ??
                                    error?.response?.data?.messages
                            );
                        })
                        .finally(() => {
                            me.closeLoading();
                        });
                }
            });
        },
    },
    mounted() {
        this.getSummary();
    },
};
</script>

<style scoped>
.form-control,
.btn {
    border-radius: 0.2rem;
}

.swal2-container {
    background-color: red;
}

.loading {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
